import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDocument',
  template: `
    <button *ngIf="params?.data.status == 'Draft' || params.data.status == 'Inactive'" [disabled]="!params.data.editDoc"
      mat-mini-fab
      color="primary"
      title="Edit"
      (click)="onClick($event)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      title="Draft Options"
      (click)="onClick($event)"
      [disabled]="params.data.disableDraft"
    >
    <mat-icon>assignment</mat-icon></button>

    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == false ? true : false"
    mat-mini-fab
    color="accent"
    title="Draft Options"
    (click)="onClick($event)"
    [disabled]="params.data.disableApproved"
  >
  <mat-icon>alarm icon</mat-icon></button>

    <button *ngIf="params?.data.status == 'Inactive'"
      mat-mini-fab
      color="warn"
      title="Draft Options"
      (click)="onClick($event)"
    >
    <mat-icon>warning</mat-icon>
    </button>
    <button [hidden]="true"
      mat-mini-fab
      color="accent"
      title="View Document"
      (click)="onClick($event)"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <button [disabled]="params.data.status == 'Draft' && params.data.disableDownload == false || params.data.status == 'Active' || params.data.status == 'Inactive' && params.data.disableDownload == false && params.data.disableOtherDownload == false || params.data.status == 'Obsolete' && params.data.disableDownload == false && params.data.disableOtherDownload == false ? false : true"
      mat-mini-fab
      color="warn"
      title="Download Document"
      (click)="onClick($event)"
    >
      <mat-icon>download</mat-icon>
    </button>

    <button
    mat-mini-fab
    color="primary"
    title="Open Chat"
    (click)="onClick($event)"
    [disabled]="params.data.disableChat"
  >
    <mat-icon>chat</mat-icon>
  </button>

  <button
    mat-mini-fab
    color="accent"
    title="Open Questions"
    (click)="onClick($event)"
    [disabled]="params?.data.status == 'Draft'"
  >
  <mat-icon>forum</mat-icon>
  </button>

    <!-----
    <button
      mat-mini-fab
      color="warn"
      style="background-color: #000;"
      title="Document Questions"
      (click)="onClick($event)"
    >
      <mat-icon>question_answer</mat-icon>
    </button>
    ---->
  `,
  styles: [
    `
      button {
        height: 35px;
        width: 35px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 3px;
      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererRevisionHistory implements ICellRendererAngularComp {
  public params: any;

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }
}
